/**
 * Configurator — German + Dutch translation tables.
 * Imported by every sub-component plus the main orchestrator.
 */

export const I18N = {
  de: {
    steps: ['Typ', 'Maße', 'Ausführung', 'Kontakt'],
    typeTitle: 'Welches Produkt brauchst du?',
    typeSub: 'Wähle den Typ, der zu deinem Fenster oder deiner Tür passt.',
    sizeTitle: 'Maße angeben',
    sizeSub: 'In Millimetern. Die Außenmaße deines Rahmens reichen — wir bestätigen sie vor Produktion.',
    width: 'Breite',
    height: 'Höhe',
    cm: 'mm',
    optionsTitle: 'Farbe und Gewebe',
    optionsSub: 'Wähle deinen Look und das passende Mesh.',
    color: 'Profilfarbe',
    mesh: 'Gewebe',
    colorNames: { white: 'Weiß', black: 'Schwarz', anthracite: 'Anthrazit', brown: 'Braun' },
    meshNames: { standard: 'Standard (Fiberglas)', pollen: 'Pollen-Schutz', pet: 'Haustier-resistent' },
    meshDescs: {
      standard: 'Robustes graues Fiberglas. Klassisch und schmal.',
      pollen: 'Engmaschig, hält bis zu 90% der Pollen draußen — perfekt für Allergiker.',
      pet: 'Verstärktes Gewebe, krallensicher und reißfest.',
    },
    contactTitle: 'Fast geschafft.',
    contactSub: 'Wir prüfen deine Konfiguration und melden uns mit einem verbindlichen Angebot.',
    name: 'Name',
    email: 'E-Mail',
    phone: 'Telefon (optional)',
    notes: 'Notiz (optional)',
    notesPh: 'Besonderheiten, Einbausituation, gewünschter Termin …',
    namePh: 'Vor- und Nachname',
    submit: 'Angebot anfragen',
    submitting: 'Wird gesendet …',
    next: 'Weiter',
    back: 'Zurück',
    summary: 'Deine Konfiguration',
    estPrice: 'Geschätzter Preis',
    estNote: 'Endpreis nach Maß-Bestätigung.',
    successTitle: 'Danke — wir melden uns.',
    successSub: 'Du erhältst innerhalb eines Werktags ein verbindliches Angebot per E-Mail.',
    newConfig: 'Neue Konfiguration starten',
    addAnother: 'Weiteres Produkt hinzufügen',
    proceed: 'Weiter zur Anfrage',
    backToList: 'Zurück zur Übersicht',
    yourItems: 'Deine Produkte',
    itemNumFmt: 'Produkt {n}',
    remove: 'Entfernen',
    edit: 'Bearbeiten',
    totalLabel: 'Gesamtpreis (Schätzung)',
    emptyCart: 'Noch keine Produkte hinzugefügt.',
    addFirst: 'Erstes Produkt konfigurieren',
    finishItem: 'Produkt übernehmen',
    shareTitle: 'Konfiguration teilen oder speichern',
    shareSub: 'Schicke dir den Link zu — du kannst alles später fortsetzen, weiterleiten oder als Erinnerung speichern.',
    shareCopy: 'Link kopieren',
    shareCopied: 'Link kopiert!',
    shareWA: 'Per WhatsApp teilen',
    shareMail: 'Per E-Mail teilen',
    shareRestored: 'Konfiguration aus Link geladen.',
    bundleBannerFmt: '{name} — Produkt {current} von {total}.',
    bundleTypeProgressFmt: '{type}: {n} von {qty} erfassen.',
    bundleRemainingFmt: 'Du hast noch {remaining} von {total} Elementen zu erfassen.',
    bundleCompleteTitle: 'Paket vollständig erfasst.',
    bundleCompleteSub: 'Schließe deine Anfrage ab — das Paket ist komplett.',
    bundleHintMore: 'Tipp: Doppel-Tap auf eine Karte springt direkt zum nächsten Schritt.',
    bundleHintLast: 'Letztes Produkt des Pakets.',
    openingDir: 'Drehrichtung',
    slideDir: 'Schieberichtung',
    dirLeft: 'Links',
    dirRight: 'Rechts',
    crossbar: 'Höhe der Sprosse',
    crossbarHint: 'Sprossen-Position über dem Boden, in mm (optional).',
    crossbarPlaceholder: 'z. B. 1050',
    shareMsgFmt: 'Hier ist meine Insektenschutz-Konfiguration ({n} Produkte, Gesamt {total}):',
    crossEyebrow: 'Empfehlung',
    crossTitle: 'Möchtest du gleich noch mehr dazu?',
    crossSubFmt: 'Mit unserem {bundle} sparst du {save} ({pct}% Rabatt).',
    crossCta: 'Paket ansehen',
    errSize: 'Maße zwischen 300 und 3000 mm.',
    errType: 'Bitte wähle einen Produkttyp.',
    errOptions: 'Bitte wähle Farbe und Gewebe.',
    errName: 'Bitte gib deinen Namen an.',
    errMail: 'Bitte gib eine gültige E-Mail-Adresse an.',
    errNet: 'Netzwerk-Fehler. Bitte versuche es erneut.',
  },
  nl: {
    steps: ['Type', 'Maten', 'Uitvoering', 'Contact'],
    typeTitle: 'Welk product heb je nodig?',
    typeSub: 'Kies het type dat past bij je raam of deur.',
    sizeTitle: 'Maten opgeven',
    sizeSub: 'In millimeters. De buitenmaten van je kozijn volstaan — we bevestigen ze voor productie.',
    width: 'Breedte',
    height: 'Hoogte',
    cm: 'mm',
    optionsTitle: 'Kleur en gaas',
    optionsSub: 'Kies je look en het juiste gaas.',
    color: 'Profielkleur',
    mesh: 'Gaas',
    colorNames: { white: 'Wit', black: 'Zwart', anthracite: 'Antraciet', brown: 'Bruin' },
    meshNames: { standard: 'Standaard (fiberglas)', pollen: 'Pollen-werend', pet: 'Huisdier-bestendig' },
    meshDescs: {
      standard: 'Stevig grijs fiberglas. Klassiek en strak.',
      pollen: 'Fijnmazig, houdt tot 90% van het pollen buiten — top voor allergici.',
      pet: 'Versterkt gaas, klauw-bestendig en scheurvast.',
    },
    contactTitle: 'Bijna klaar.',
    contactSub: 'We checken je configuratie en sturen je een bindende offerte.',
    name: 'Naam',
    email: 'E-mail',
    phone: 'Telefoon (optioneel)',
    notes: 'Opmerking (optioneel)',
    notesPh: 'Bijzonderheden, montage-situatie, gewenste datum …',
    namePh: 'Voor- en achternaam',
    submit: 'Offerte aanvragen',
    submitting: 'Wordt verzonden …',
    next: 'Verder',
    back: 'Terug',
    summary: 'Jouw configuratie',
    estPrice: 'Geschatte prijs',
    estNote: 'Definitieve prijs na bevestiging van de maten.',
    successTitle: 'Bedankt — we nemen contact op.',
    successSub: 'Je ontvangt binnen 1 werkdag een bindende offerte per e-mail.',
    newConfig: 'Nieuwe configuratie starten',
    addAnother: 'Nog een product toevoegen',
    proceed: 'Door naar aanvraag',
    backToList: 'Terug naar overzicht',
    yourItems: 'Jouw producten',
    itemNumFmt: 'Product {n}',
    remove: 'Verwijderen',
    edit: 'Bewerken',
    totalLabel: 'Totaalprijs (schatting)',
    emptyCart: 'Nog geen producten toegevoegd.',
    addFirst: 'Eerste product configureren',
    finishItem: 'Product overnemen',
    shareTitle: 'Configuratie delen of bewaren',
    shareSub: 'Stuur jezelf de link — je kunt later verder gaan, doorsturen of opslaan als herinnering.',
    shareCopy: 'Link kopiëren',
    shareCopied: 'Link gekopieerd!',
    shareWA: 'Via WhatsApp delen',
    shareMail: 'Via e-mail delen',
    shareRestored: 'Configuratie uit link geladen.',
    bundleBannerFmt: '{name} — product {current} van {total}.',
    bundleTypeProgressFmt: '{type}: {n} van {qty} invoeren.',
    bundleRemainingFmt: 'Je hebt nog {remaining} van {total} elementen in te voeren.',
    bundleCompleteTitle: 'Pakket volledig ingevoerd.',
    bundleCompleteSub: 'Rond je aanvraag af — het pakket is compleet.',
    bundleHintMore: 'Tip: dubbel-tikken op een kaart springt direct naar de volgende stap.',
    bundleHintLast: 'Laatste product van het pakket.',
    openingDir: 'Draairichting',
    slideDir: 'Schuifrichting',
    dirLeft: 'Links',
    dirRight: 'Rechts',
    crossbar: 'Hoogte van de dwarsbalk',
    crossbarHint: 'Positie van de dwarsbalk boven de vloer, in mm (optioneel).',
    crossbarPlaceholder: 'bv. 1050',
    shareMsgFmt: 'Hier is mijn horren-configuratie ({n} producten, totaal {total}):',
    crossEyebrow: 'Aanbevolen',
    crossTitle: 'Wil je er gelijk meer bij?',
    crossSubFmt: 'Met ons {bundle} bespaar je {save} ({pct}% korting).',
    crossCta: 'Pakket bekijken',
    errSize: 'Maten tussen 300 en 3000 mm.',
    errType: 'Kies een producttype.',
    errOptions: 'Kies kleur en gaas.',
    errName: 'Vul je naam in.',
    errMail: 'Vul een geldig e-mailadres in.',
    errNet: 'Netwerk-fout. Probeer het opnieuw.',
  },
};

export const pickI18N = (lang) => I18N[lang] || I18N.nl;
